;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { OffsooWordmark } from '@/components/site/chrome/offsoo-wordmark'
import { Container } from '@/components/ui/container'
import { Link } from '@/components/ui/link'
import { getPagePath, type Locale } from '@/i18n/routing'
import type { ReactNode } from 'react'

/**
 * The chrome the signup and login screens carry instead of the site's navigation and footer: the
 * wordmark, one link to the other side of the door, and a legal line.
 *
 * Someone who has come this far has already decided to look; a full navigation at the top of a
 * signup form is an invitation to leave it. What stays is the way back to the homepage, the way to
 * the screen they may have meant instead, and the terms they are agreeing to.
 */
export function FlowChrome({
  locale,
  prompt,
  linkLabel,
  linkHref,
  legal,
  children,
}: {
  locale: Locale
  /** "Nog geen account?" — the question the link answers. */
  prompt: string
  linkLabel: string
  linkHref: string
  legal: { copyright: string; terms: string; privacy: string }
  children: ReactNode
}) {
  // Above and below the wallpaper card, on the light page — the same place, container and colours
  // the site's own navigation and footer use, so this reads as a page of this site.
  return (
    <div className="flex min-h-svh flex-col">
      <header>
        {/* The same height and the same wordmark as the site's own navigation, so the card below
            starts exactly where the homepage's does. */}
        <Container className="flex items-center justify-between gap-4 py-6">
          <Link href={getPagePath(locale, 'home')} unstyled className="inline-flex items-center">
            <OffsooWordmark className="h-9" />
          </Link>
          <span className="text-sm text-mist-600 dark:text-mist-400">
            {/* The question is context, not the control: on a phone it wraps onto the wordmark, so
                only the link it answers survives. */}
            <span className="max-sm:hidden">{prompt} </span>
            <Link href={linkHref} unstyled className="font-semibold text-accent-deep dark:text-accent-bright">
              {linkLabel} →
            </Link>
          </span>
        </Container>
      </header>

      <main className="flex flex-1 flex-col justify-center">{children}</main>

      <Container className="flex flex-wrap justify-center gap-x-5 gap-y-1.5 py-5 text-xs text-mist-500 sm:py-6 dark:text-mist-400">
        <span>{legal.copyright}</span>
        <Link href={getPagePath(locale, 'legal-terms')} unstyled className="hover:text-mist-950 dark:hover:text-white">
          {legal.terms}
        </Link>
        <Link
          href={getPagePath(locale, 'legal-privacy')}
          unstyled
          className="hover:text-mist-950 dark:hover:text-white"
        >
          {legal.privacy}
        </Link>
      </Container>
    </div>
  )
}
